import { render, staticRenderFns } from "./build.vue?vue&type=template&id=5fa4348a"
import script from "./build.vue?vue&type=script&lang=js"
export * from "./build.vue?vue&type=script&lang=js"
import style0 from "./build.vue?vue&type=style&index=0&id=5fa4348a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports